import { LT_POLYLINE_TYPES, StopStatuses } from '@jumbo/constants/AppConstants';
import { store } from 'App';
import {
  getAllCurrentDispatchesApi,
  getAllJourneysApi,
  getDispatchesCountApi,
  getJourneyApi,
  getJourneyByUserIdApi,
  getJourneysbyUserApi,
  getLatestLocationForLoadApi,
  getLatestLocationForMultipleLoadsApi,
  getLocationsbyJourneyIdApi,
  getSelectedDispatchByIdApi,
  getSelectedDispatchByPublicIdApi,
  addCallLogForDispatchApi,
  getAdminDetailsByIdsApi,
  getTrackingLoadsApi,
  getTruckLocationHistoryByLoadIdApi
} from 'redux/apis/tracking';
import { getCarrierRepsListApi } from 'redux/apis/Users';
import { isTheCurrentStatusChangedToDeliveredInFinalStop } from 'redux/helper/helper';
import { fetchError, fetchStart, fetchSuccess, postSuccess  } from './Common';

export const GET_ALL_JOURNEYS_SUCCESSFUL = 'GET_ALL_JOURNEYS_SUCCESSFUL';

export function getAllJourneys(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getAllJourneysApi(data)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_ALL_JOURNEYS_SUCCESSFUL,
            payload: res.data,
            lastEvaluatedKey: res.lastEvaluatedKey,
          });
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export const GET_JOURNEY_SUCCESSFUL = 'GET_JOURNEY_SUCCESSFUL';

export function getJourney(id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getJourneyApi(id)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_JOURNEY_SUCCESSFUL,
            payload: res,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export function getJourneysByUser(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getJourneysbyUserApi(data)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_ALL_JOURNEYS_SUCCESSFUL,
            payload: res.data,
            lastEvaluatedKey: res.lastEvaluatedKey,
          });
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError());
          reject(err);
        });
    });
  };
}

export function getJourneyByUserId(id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getJourneyByUserIdApi(id)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_JOURNEY_SUCCESSFUL,
            payload: res,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export const GET_LOCATIONS_SUCCESSFUL = 'GET_LOCATIONS_SUCCESSFUL';

export function getLocationsbyJourneyId(id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getLocationsbyJourneyIdApi(id)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_LOCATIONS_SUCCESSFUL,
            payload: res.data,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export const GET_DISPATCHES_REQUEST = "GET_DISPATCHES_REQUEST";
export const GET_DISPATCHES_SUCCESS = 'GET_DISPATCHES_SUCCESS';
export const GET_DISPATCHES_NEXT_PAGE_SUCCESS = 'GET_DISPATCHES_NEXT_PAGE_SUCCESS';
export function getAllCurrentDispatches(params, reset = false) {
  return dispatch => {
    dispatch({ 
      type: GET_DISPATCHES_REQUEST, 
      reset: reset
    })
    return new Promise((resolve, reject) => {
      getAllCurrentDispatchesApi(params)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: params.start == 0 ? GET_DISPATCHES_SUCCESS : GET_DISPATCHES_NEXT_PAGE_SUCCESS,
            payload: res,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export const SEARCH_DISPATCHES_SUCCESS = 'SEARCH_DISPATCHES_SUCCESS';
export function searchDispatches(params) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getAllCurrentDispatchesApi(params)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: SEARCH_DISPATCHES_SUCCESS,
            payload: res,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export const SET_SELECTED_DISPATCH_SUCCESS = 'SET_SELECTED_DISPATCH_SUCCESS';
export function setSelectedDispatch(selectedLoad) {
  return dispatch => {
    dispatch({
      type: SET_SELECTED_DISPATCH_SUCCESS,
      payload: selectedLoad,
    });
  };
}

export const GET_SELECTED_DISPATCH_SUCCESS = 'GET_SELECTED_DISPATCH_SUCCESS';
export function getSelectedDispatchById(id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getSelectedDispatchByIdApi(id)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_SELECTED_DISPATCH_SUCCESS,
            payload: res.data,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export const GET_SELECTED_DISPATCH_WITH_PUBLIC_ID_SUCCESS = 'GET_SELECTED_DISPATCH_WITH_PUBLIC_ID_SUCCESS';
export function getSelectedDispatchByPublicId(id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getSelectedDispatchByPublicIdApi(id)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_SELECTED_DISPATCH_WITH_PUBLIC_ID_SUCCESS,
            payload: res.data,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export const GET_LATEST_LOCATION_FOR_LOAD_SUCCESS = 'GET_LATEST_LOCATION_FOR_LOAD_SUCCESS';
export const GET_LATEST_LOCATION_FOR_LOAD_FAILED = 'GET_LATEST_LOCATION_FOR_LOAD_FAILED'
export function getLatestLocationForLoad(id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getLatestLocationForLoadApi(id)
        .then(res => {

          //if a location for truck is received for the first time - > redraw route (for live update)
          let redrawRoute = ((store.getState().tracking?.selectedLoadLocation?.location === null)
                              && res?.data?.location?.geometry)
          // if the driver marks the status of the final stop as delivered,
          // re render map to show the delivered screen(for live update)
          let isDeliveredJustNow = isTheCurrentStatusChangedToDeliveredInFinalStop(store, res);

          dispatch({
            type: GET_LATEST_LOCATION_FOR_LOAD_SUCCESS,
            payload: res.data,
            tracking_status: "Tracking"
          });

          if(redrawRoute){
            console.log("LOCATION RECEIVED FOR THE FIRST TIME")
            dispatch({
              type: REDRAW_ROUTE_ON_MAP,
              payload: {
                [LT_POLYLINE_TYPES.ROUTE_TO_NEXT_STOP]:true,
                [LT_POLYLINE_TYPES.FULL_ROUTE]:true
              },
            });
          }

          if(isDeliveredJustNow){
            // for updating routes in real time
            dispatch({
              type: GET_SELECTED_DISPATCH_SUCCESS,
              payload: {...store.getState().tracking?.selectedLoad, status: StopStatuses.DELIVERED},
            });
            dispatch({
              type:REDRAW_ROUTE_ON_MAP,
              payload:{
                deleteOtherRoutes:true,
                [LT_POLYLINE_TYPES.FULL_ROUTE]:true
              }
            });
            // dispatch(reRenderMap(true))
          }

          resolve(res);
        })
        .catch(err => {
          dispatch({
            type: GET_LATEST_LOCATION_FOR_LOAD_FAILED,
            tracking_status: "Not Tracking",
          });
          reject(err);
        });
    });
  };
}

export const GET_LATEST_LOCATION_FOR_MULTIPLE_LOADS_SUCCESS = 'GET_LATEST_LOCATION_FOR_MULTIPLE_LOADS_SUCCESS';
export function getLatestLocationForMultipleLoads(params) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getLatestLocationForMultipleLoadsApi(params)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_LATEST_LOCATION_FOR_MULTIPLE_LOADS_SUCCESS,
            payload: res.data,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
}

export const GET_DISPATCHES_COUNT = "GET_DISPATCHES_COUNT";
export function getDispatchesCount(){
  return dispatch => {
    return new Promise((resolve, reject) => {
      getDispatchesCountApi()
        .then(res => {
          dispatch({
            type: GET_DISPATCHES_COUNT,
            payload: res.data
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export const ADD_CALL_LOG_FOR_DISPATCH = "ADD_CALL_LOG_FOR_DISPATCH";
export function addCallLogForDispatch(dispatch_id, data){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      addCallLogForDispatchApi(dispatch_id, data)
        .then(res => {
          dispatch(postSuccess('Call log added successfully'));
          dispatch(fetchSuccess());
          delete res?.data?.dispatch
          dispatch({
            type: ADD_CALL_LOG_FOR_DISPATCH,
            payload: res.data
          });
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError(error?.response?.data?.error ?? "Failed to add call log"));
          reject(error);
        });
    });
  }
}

export const GET_ADMIN_DATA_BY_IDS = "GET_ADMIN_DATA_BY_IDS";
export function getAdminDetailsByIds(params){
  return dispatch => {
    return new Promise((resolve, reject) => {
      getAdminDetailsByIdsApi(params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError(error?.response?.data?.error ?? "Failed to fetch admin details"));
          reject(error);
        });
    });
  }
}

export const RE_RENDER_MAP = "RE_RENDER_MAP";
export function reRenderMap(value){ 
  return dispatch => {
    dispatch({
      type: RE_RENDER_MAP,
      payload: value
    })
  }
}

export const GET_TRACKING_LOADS = 'GET_TRACKING_LOADS'
export function getTrackingLoads(data = {}) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart())
      getTrackingLoadsApi(data)
        .then(res => {
          dispatch(fetchSuccess())
          dispatch({
            type: GET_TRACKING_LOADS,
            payload: res.dispatches,
            isAppend: data.start > 0,
            totalLoads : res.total_count
          });

          dispatch(
            getLatestLocationForMultipleLoads({
              ids: res.dispatches
                .map(load => load.id)
                .join(','),
            }),
          ).then().catch();

          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError())
          reject(err);
        });
    });
  }
}

export const GET_CARRIER_REP_LIST = 'GET_CARRIER_REP_LIST'
export function getCarrierRepsList(){
  return dispatch => {
    return new Promise((resolve, reject) => {
      getCarrierRepsListApi()
        .then(res => {
          dispatch({
            type: GET_CARRIER_REP_LIST,
            payload: res?.data?.carrier_reps ?? []
          });
          resolve(res.data);
        })
        .catch(err => {
          dispatch(fetchError("Failed to fetch carrier rep details"))
          reject(err)
        });
    });
  }
}

export const REDRAW_ROUTE_ON_MAP = 'REDRAW_ROUTE_ON_MAP'
export function redrawTruckRoute(payload){
  return dispatch => {
    dispatch({
      type: REDRAW_ROUTE_ON_MAP,
      payload: payload
    });
  }
}

export const ADD_LOCATION_HISTORY_FOR_LOAD = 'ADD_LOCATION_HISTORY_FOR_LOAD'
export function getTruckLocationHistoryForLoad(loadId){
  return dispatch => {
    return new Promise((resolve, reject) => {
      getTruckLocationHistoryByLoadIdApi(loadId)
        .then(res => {
          dispatch({
            type: ADD_LOCATION_HISTORY_FOR_LOAD,
            payload: {loadId:loadId, locationsHistory:res?.data ?? []}
          });
          resolve(res.data);
        })
        .catch(err => {
          dispatch(fetchError("Failed to fetch locations history for load"))
          reject(err)
        });
    });
  }
}

export const CLEAN_UP_SELECTED_LOAD_AND_LOCATION = "CLEAN_UP_SELECTED_LOAD_AND_LOCATION";
export function cleanUpSelectedLoadAndLocationInRedux(){
  return dispatch => {
    dispatch({
      type: CLEAN_UP_SELECTED_LOAD_AND_LOCATION
    })
  }
}